import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Message,SelectItem } from 'primeng/api';
import QrScanner from 'qr-scanner';
import { interval } from 'rxjs';
import { Login } from '../../../observation/model/login.model';
import { ObservationService } from '../../../observation/services/observation.service';
import { UserPermissionParameters } from '../../../shared/models/user.model';
import { BaseService } from '../../../shared/services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { ConstantsService } from '../../../shared/services/constants.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { CheckInCheckOutUser, MasterRequest, Request } from '../../model/masterrequest.model';
import { POBPermissionDetails } from '../../model/POBPermissions.model';
import { PersononboardConstantsService } from '../../services/persononboard-constants.service';
import { PersononboardService } from '../../services/persononboard.service';

@Component({
  selector: 'checkin-out',
  templateUrl: './checkin-out.component.html',
  styleUrls: ['./checkin-out.component.css']
})

export class CheckinOutComponent implements OnInit, OnDestroy {
  loggedInUserJSON: any;
  isShowPassDetails: boolean = false;
  routesFlag: { routeName: string; routeURL: string; isClickable:boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable:boolean; }[];
  checkInCheckOutDetails: CheckInCheckOutUser[] = [];
  PassIdFromQrCode: string;
  passRequestForFormData: Request;
  passRequestForData: MasterRequest;
  passTypeRowNameValue: string;
  passTypeRowIdValue: number;
  tempFiles: any[];
  PassRequestId: any;
  PersonName: any;
  FromDate: any;
  ExpiryDate: any;
  PassType: string;
  QRCode: any;
  PhotoURL: string;
  alertType: string;
  successDetails: string;
  isUserAutheticated: boolean;
  display: boolean;
  searchText: string;
  searchModified: boolean;
  passStatus: any;
  checkInSuccess: boolean;
  videoDevices: MediaDeviceInfo[] = [];
  choosenDev: any;
  POBPermission: POBPermissionDetails;
  userPermissions: UserPermissionParameters;
  currentDate: Date;
  isDisabled: boolean = false;
  errorDetails: string;
  confirmMessage: string;
  isCheckInDisabled: boolean = false;
  isCheckOutDisabled: boolean = false;
  offlinePassRequestIds: any[] = [];
  isOnline: boolean = true;
  offlineRoutes: any;
  isShowOffline: boolean;
  independentPermissions: any;
  qrScanner: any;
  hasCamera: boolean = true;
  Location: string = '';
  printPass: string;
  locations: SelectItem[];
  selectedLocation: any;
  passWarning: Message[] = [];

  constructor(private baseService: BaseService,
    private pobServices: PersononboardService,
    private router: Router,
    private commonService: CommonService,
    private notificationsService: NotificationsService,
    private translate: TranslateService,
    private observationService: ObservationService) {
    this.passRequestForFormData = new Request();
    this.passRequestForData = new MasterRequest();
    this.isShowPassDetails = false;
    this.POBPermission = new POBPermissionDetails();
    this.userPermissions = new UserPermissionParameters();
    this.currentDate = new Date();
    this.offlinePassRequestIds = [];
    this.checkInCheckOutDetails = [];
  }

  ngOnInit() {
    this.checkOnlineStatus();
    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.baseService.setItemInSession('offlineRoutes', JSON.stringify(this.routesFlag));
    const routes = JSON.stringify(PersononboardConstantsService.PersonOnBoardUrl.InnerRoutes);
    this.routesFlag = JSON.parse(routes);
    this.reportRoutes = PersononboardConstantsService.PersonOnBoardUrl.ReportRoutes;
    this.commonService.getUserIndependentPermissions(this.loggedInUserJSON.UserId);
    this.independentPermissions = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
    if (!this.independentPermissions.POB_Contractor_Add &&
      !this.independentPermissions.POB_Contractor_Add_Unit &&
      !this.independentPermissions.POB_Staff_Add &&
      !this.independentPermissions.POB_Staff_Add_Unit &&
      !this.independentPermissions.POB_Admin &&
      !this.independentPermissions.POB_Admin_Unit) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === "New Pass") {
          this.routesFlag.splice(index, 1);
          break;
        }
      }
    }
    this.scanQrCode();
    this.isShowPassDetails = false;
    if (!navigator.onLine) {
      const routes = JSON.stringify(PersononboardConstantsService.PersonOnBoardUrl.OfflineRoutes);
      this.routesFlag = JSON.parse(routes);
      this.baseService.setItemInSession('offlineSplicedRoutes', JSON.stringify(this.routesFlag));
      this.getOfflineData();
      const checkInDetails = new CheckInCheckOutUser();
      checkInDetails.CheckInTime = new Date();
      checkInDetails.CheckOutTime = null;
      checkInDetails.InOrOut = 'CheckIn';
      checkInDetails.PassId = this.PassIdFromQrCode;
      checkInDetails.UserId = this.loggedInUserJSON.UserId;
      this.offlinePassRequestIds.push(checkInDetails);
    }
    this.getLocations();
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }

  scanQrCode() {
    navigator.mediaDevices.getUserMedia({ video: true }).then(() => {
      this.hasCamera = true
    }, () => this.hasCamera = false);
    if (this.hasCamera) {
      this.detectWebcam((anyCamera) => {
        if (anyCamera) {
          const videoElem = document.getElementsByTagName("video")[0];
          QrScanner.WORKER_PATH = './assets/js/qr-scanner-worker.min.js';
          this.qrScanner = new QrScanner(videoElem, result => {
            this.PassIdFromQrCode = result;
            this.qrScanner.stop();
            this.qrScanner._qrWorker.terminate();
            if (this.isOnline) {
              this.getDetailsByPassReuestId(this.PassIdFromQrCode);
            } else {
              this.notificationsService.toastNotify('success', 'Success Message', 'User Authenticated Successfully');
              this.isShowOffline = true;
            }
          });
          this.qrScanner.start();
        } else {
          this.hasCamera = false;
        }
      });
    }
  }
  getOfflineData() {
    this.offlineRoutes = JSON.parse(this.baseService.getItemFromSession('offlineSplicedRoutes'));
    if (this.offlineRoutes !== null) {
      this.routesFlag = this.offlineRoutes;
    }
    if (this.offlineRoutes !== null) {
      this.routesFlag = this.offlineRoutes;
    }
  }
  checkOnlineStatus() {
    const repeatCheck = interval(15000);
    repeatCheck.subscribe(val => {
      if (navigator.onLine) {
        this.isOnline = true;
        this.processOfflinePassRequest();
      }
      else {
        this.isOnline = false;
      }
    });
    if (this.isOnline) {
      this.routesFlag = JSON.parse(this.baseService.getItemFromSession('offlineRoutes'));
    } else {
      this.routesFlag = JSON.parse(this.baseService.getItemFromSession('offlineSplicedRoutes'));
    }
  }

  processOfflinePassRequest() {
    if (this.offlinePassRequestIds.length > 0) {
      if (this.independentPermissions.POB_SecurityCheckInOut) {
        this.offlineCheckIn(this.offlinePassRequestIds);
      }
    }
  }

  getDetailsByPassReuestId(passRequestId) {
    this.PassIdFromQrCode = passRequestId;
    const apiRequest = {
      Model: {
        PassId: this.PassIdFromQrCode
      }
    };
    this.pobServices.getPassRequestDetailsByPassId(apiRequest, this.callbackMethodForGetDetailsPassId.bind(this));
  }

  offlineCheckIn(PassRequest) {
    this.checkInCheckOutDetails = PassRequest;
    const apiRequest = {
      Model: {
        'CheckInCheckOutDetails': this.checkInCheckOutDetails
      }
    };
    this.pobServices.insertCheckInCheckOutDetails(apiRequest, this.callbackMethodForofflineGetcheckInDetails.bind(this));
  }
  checkIn(status) {
    this.isDisabled = true;
    this.passStatus = status;
    const checkInDetails: CheckInCheckOutUser = new CheckInCheckOutUser();
    checkInDetails.UserId = this.loggedInUserJSON.UserId;
    if (this.searchModified) {
      checkInDetails.PassId = this.searchText;
    } else {
      checkInDetails.PassId = this.PassIdFromQrCode;
    }
    if (status === 'CheckIn') {
      checkInDetails.CheckInTime = new Date();
      checkInDetails.CheckInLocation = this.Location;
      checkInDetails.CheckOutTime = null;
      checkInDetails.CheckOutLocation = null;
      checkInDetails.InLocation = this.selectedLocation;
    } else {
      checkInDetails.CheckInTime = null;
      checkInDetails.CheckInLocation = null;
      checkInDetails.CheckOutTime = new Date();
      checkInDetails.CheckOutLocation = this.Location;
      checkInDetails.OutLocation = this.selectedLocation;
    }
    checkInDetails.InOrOut = status;
    if (this.isOnline) {
      this.checkInCheckOutDetails.push(checkInDetails);
      const apiRequest = {
        Model: {
          'CheckInCheckOutDetails': this.checkInCheckOutDetails
        }
      };
      this.pobServices.insertCheckInCheckOutDetails(apiRequest, this.callbackMethodForGetcheckInDetails.bind(this));
    } else {
      this.offlinePassRequestIds.push(checkInDetails);
      this.scanQrCode();
      this.isShowOffline = true;
      this.isDisabled = false;
    }
    this.checkInCheckOutDetails = [];
  }
  callbackMethodForofflineGetcheckInDetails(response) {
    if (response.Success) {
      if (response && response.Success) {
        this.notificationsService.toastNotify('success', 'Success Message', 'Offline data saved successfully');
        this.offlinePassRequestIds = [];
        this.ngOnInit();
      } else {
        this.notificationsService.toastNotify('error', 'Error Message', 'Something went wrong!');
      }
      this.baseService.showRootLoader = false;
    }
  }

  callbackMethodForGetcheckInDetails(response) {
    if (response.Success) {
      if (response && response.Success) {
        this.notificationsService.toastNotify('success', 'Success Message', this.passStatus === 'CheckIn' ? 'User checked in details saved successfully' : 'User checked out details saved successfully');
        this.checkInSuccess = true;
        this.isShowPassDetails = false;
        this.offlinePassRequestIds = [];
        this.ngOnInit();
      } else {
        this.notificationsService.toastNotify('error', 'Error Message', 'Something went wrong!');
      }
      this.baseService.showRootLoader = false;
      this.scanQrCode();
    }
    this.isDisabled = false;
  }

  callbackMethodForGetDetailsPassId(response) {
    this.baseService.showRootLoader = false;
    if (response.Result && response.Result.RequestInfo && response.Result.RequestInfo.IsPassExists > 0) {
      // Print Pass Data Assignment Start
      this.passRequestForData = response.Result;
      this.passRequestForFormData = response.Result.RequestInfo;
      this.PassRequestId = this.passRequestForFormData.PassRequestId;
      this.printPass = this.passRequestForFormData.PrintPass;
      if(!this.passRequestForData.CheckInOutDetails.length){
        this.passWarning = [{ severity: "warn", summary: 'User has not confirmed his entry using confirmation email link. Unable to add check-in/check-out details' }];
      }else{
        this.passWarning = [];
      }
      this.isCheckInDisabled = true;
      this.isCheckOutDisabled = true;
      //this.isCheckInDisabled = this.passRequestForData.CheckInOutDetails.length ? this.passRequestForData.CheckInOutDetails[0].InOrOut === "In" : true;
      //this.isCheckOutDisabled = this.passRequestForData.CheckInOutDetails.length ? this.passRequestForData.CheckInOutDetails[0].InOrOut === "Out" : true;
      this.isCheckInDisabled = this.passRequestForData.CheckInOutDetails.length ? this.passRequestForData.CheckInOutDetails[0].InOrOut === "In" : false;//Pritesh
      this.isCheckOutDisabled = this.passRequestForData.CheckInOutDetails.length ? this.passRequestForData.CheckInOutDetails[0].InOrOut === "Out" : true;//Pritesh

      this.isUserAutheticated = true;
      if (this.passRequestForFormData.PassStatusName === 'Pending For Approval') {
        this.notificationsService.toastNotify('warn', 'Warning Message', 'Pass is Pending for Approval');
        this.scanQrCode();
      } else if (this.passRequestForFormData.PassStatusName === 'Expired') {
        this.notificationsService.toastNotify('warn', 'Warning Message', 'This Pass has been Expired!');
        this.scanQrCode();
      } else if (this.passRequestForFormData.Blocked) {
        this.notificationsService.toastNotify('warn', 'Warning Message', 'This Pass has been blocked till ' + moment(moment.utc(this.passRequestForFormData.ExpiryDate).local()).format('MMM D, YYYY'));
        this.scanQrCode();
      } else {
        this.isShowPassDetails = true;
        this.notificationsService.toastNotify('success', 'Success Message', 'User Authenticated Successfully');
        this.getPermissionDetails();
      }
    } else {
      this.notificationsService.toastNotify('info', 'Information Message', 'No Such pass exists!!!');
      this.scanQrCode();
    }
  }

  close() {
    this.isShowPassDetails = false;
    this.ngOnInit();
  }

  onOkClicked() {
    this.alertType = null;
    this.successDetails = null;
    if (this.isUserAutheticated && this.checkInSuccess) {
      this.router.navigate(['pob/pob-list-overview']);
    }
    // this.closePopup = false;
  }

  searchData() {
    this.baseService.showRootLoader = true;
    this.searchModified = true;
    const apiRequest = {
      Model: {
        PassId: this.searchText
      }
    };
    this.pobServices.getPassRequestDetailsByPassId(apiRequest, this.callbackMethodForGetDetailsPassId.bind(this));
  }
  getPermissionDetails() {
    this.userPermissions.ModuleId = ConstantsService.PermissionMatrixModules.POB;
    this.userPermissions.UserId = this.loggedInUserJSON.UserId;
    this.userPermissions.UnitId = this.passRequestForData.MasterUnitId;
    const apiRequest = {
      Model: this.userPermissions
    };
    this.commonService.getPermissionDetailsForUser(apiRequest, this.callbackMethodForgetPermissionDetails.bind(this));
  }

  callbackMethodForgetPermissionDetails(response) {
    const permissions = response.Result;
    if (response.Result) {
      this.POBPermission = permissions.POBPermission;
    }
  }
  onYesClickedForConfirmation() { }
  onNoClickedForConfirmation() { }
  detectWebcam(callback) {
    let md = navigator.mediaDevices;
    if (!md || !md.enumerateDevices) return callback(false);
    md.enumerateDevices().then(devices => {
      callback(devices.some(device => 'videoinput' === device.kind));
    })
  }
  ngOnDestroy() {
    if (this.qrScanner) {
      this.qrScanner.stop();
      this.qrScanner.destroy();
    }
  }

  getLocation(location) {
    this.Location = location;
  }

  // method to get the location
  getLocations() {
    let login = new Login();
    login.UnitId = 0;
    const apiRequest = {
      Model: login,
    };
    // Call dummy method to post data
    this.observationService.getLocationData(
      apiRequest,
      this.callbackMethodForGetLocationData.bind(this)
    );
  }

  // call back method of get location
  callbackMethodForGetLocationData(response) {
    let locationDetails = [];
    this.locations = [];
    if (response === undefined) {
      locationDetails = JSON.parse(
        this.baseService.getItemFromSession("locations_1")
      );
    } else {
      if (response.Success) {
        locationDetails = response.Result;
      }
      if (response.Errors !== null) {
        this.notificationsService.toastNotify(
          "error",
          "Error Message",
          "Location list is empty."
        );
      }
    }
    locationDetails.forEach((location) => {
      this.locations.push({
        label: location.LocationName,
        value: location.LocationId,
      });
    });
  }
}
